import { css } from 'linaria';

export const charGroupContainer = css`
  margin-top: var(--space-150) !important;
`;

export const inactiveFilter = css`
  /* overriding fronton styles */
  color: var(--text-minor) !important;
  cursor: default !important;
  pointer-events: none !important;
`;
